import React from "react";
import "./BackdropSection.css";

const backdropSection = props => (
  <div className="BackdropSection">{props.children}</div>
);

export default backdropSection;
